import {
  StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Entypo from '@expo/vector-icons/Entypo';
import { Button, Toast } from 'native-base';

export default function SupportScreen() {
  const navigation = useNavigation();

  const openMaliMessage = ()=>{
    try{
      window.open("mailto:support@snackbook.cc");
    } catch(e){
      Toast.show({
        title: "Please install Mali app",
        bgColor: "rgba(255,0,0,0.4)",
        placement: "top", 
      })
    }
  }

  return (
    <View style={styles.container}>
      <Button style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        borderRadius: 100, position: "absolute",
        top: 10, left: 10, padding: 4, zIndex: 9,
      }} onPress={()=> navigation.goBack() }>
        <Entypo name="chevron-left" size={24} color="#FFFFFF" />
      </Button>
      
      <View style={{ padding: 10 }}>
        <Text style={{
          color: "#FFFFFF", fontSize: 20, fontWeight: "700",
          textAlign: "center"
        }}>
          Support
        </Text>
      </View>
      
      <View style={{ padding: 26 }}>
        <Text style={{ color: "#FFFFFF", fontSize: 14, textAlign: "center" }}>
          Dear user, if you encounter any problems while using Snack Puzzle App, you can seek technical assistance through this method or send an email to your email address on the app:
        </Text>
        <View style={{ flexDirection: "row", justifyContent: "center", gap: 8 }}>
          <Text style={{ color: "#FFFFFF", fontSize: 14, fontWeight: "700" }}>
            support@snackbook.cc
          </Text>
          <Text style={{ color: "#FFFFFF", fontSize: 14 }}>
            Leaving a message.
          </Text>
        </View>
      </View>
      <View style={{ padding: 26, paddingTop: 0 }}>
        <Text style={{ color: "#FFFFFF", fontSize: 14, textAlign: "center" }}>
          If you encounter any unacceptable content while using this app, please contact us immediately and we will take action as soon as possible.
        </Text>
      </View>
      <View style={{ padding: 26, paddingTop: 4 }}>
        <TouchableOpacity style={{
          height: 40, borderRadius: 6, paddingLeft: 10, paddingRight: 10,
          backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
          flexDirection: "row", alignItems: "center", justifyContent: "center"
        }} onPress={openMaliMessage}>
          <Text style={{
            fontSize: 18, color: "#FFFFFF", fontWeight: "700"
          }}>Contact Us</Text>
        </TouchableOpacity>
      </View>

    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(25,27,44)',
  },
});